import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 8h4","key":"svg-0"}],["path",{"d":"M9 8v8","key":"svg-1"}],["path",{"d":"M18 8h-2a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2v-4h-1","key":"svg-2"}]]

const IconMathTg = createReactComponent('outline', 'math-tg', 'MathTg', __iconNode);

export default IconMathTg;